// extracted by mini-css-extract-plugin
export var quantityInput = "_hs-0";